import { LEGACY_SESSION_STORAGE_KEYS } from '@easyflow/ui-frontend';

export const AUTH_STORAGE_KEYS = {
  TOKEN: 'edgvoip_tenant_token',
  REFRESH_TOKEN: 'edgvoip_tenant_refresh_token',
  USER: 'edgvoip_tenant_user',
  TENANT_SLUG: 'edgvoip_tenant_slug',
  IMPERSONATION_TOKEN: 'edgvoip_impersonation_token',
  IMPERSONATION_INFO: 'edgvoip_impersonation_info',
  MASTER_BACKUP_TOKEN: 'edgvoip_master_backup_token',
  /** Policy di sessione (JSON `SessionPolicy`) ricevuta da login/refresh, letta all'avvio del motore condiviso. */
  SESSION_POLICY: 'edgvoip_tenant_session_policy',
} as const;

export const LEGACY_STORAGE_KEYS = {
  TOKEN: 'token',
  AUTH_TOKEN: 'auth_token',
  USER: 'user',
  TENANT_SLUG: 'tenant_slug',
  IMPERSONATION_TOKEN: 'impersonation_token',
  IMPERSONATION_INFO: 'impersonation_info',
} as const;

export function migrateAuthStorage(): void {
  const legacyToken = localStorage.getItem(LEGACY_STORAGE_KEYS.TOKEN) || 
                      localStorage.getItem(LEGACY_STORAGE_KEYS.AUTH_TOKEN);
  const legacyUser = localStorage.getItem(LEGACY_STORAGE_KEYS.USER);
  const legacySlug = localStorage.getItem(LEGACY_STORAGE_KEYS.TENANT_SLUG);
  const legacyImpToken = localStorage.getItem(LEGACY_STORAGE_KEYS.IMPERSONATION_TOKEN);
  const legacyImpInfo = localStorage.getItem(LEGACY_STORAGE_KEYS.IMPERSONATION_INFO);

  if (legacyToken && !localStorage.getItem(AUTH_STORAGE_KEYS.TOKEN)) {
    try {
      const payload = JSON.parse(atob(legacyToken.split('.')[1]!));
      if (!payload.is_master_tenant) {
        localStorage.setItem(AUTH_STORAGE_KEYS.TOKEN, legacyToken);
        console.log('[Auth Migration] Migrated tenant token to new key');
      }
    } catch (e) {
      console.warn('[Auth Migration] Failed to parse legacy token');
    }
  }

  if (legacyUser && !localStorage.getItem(AUTH_STORAGE_KEYS.USER)) {
    localStorage.setItem(AUTH_STORAGE_KEYS.USER, legacyUser);
    console.log('[Auth Migration] Migrated user to new key');
  }

  if (legacySlug && !localStorage.getItem(AUTH_STORAGE_KEYS.TENANT_SLUG)) {
    localStorage.setItem(AUTH_STORAGE_KEYS.TENANT_SLUG, legacySlug);
    console.log('[Auth Migration] Migrated tenant_slug to new key');
  }

  if (legacyImpToken && !localStorage.getItem(AUTH_STORAGE_KEYS.IMPERSONATION_TOKEN)) {
    localStorage.setItem(AUTH_STORAGE_KEYS.IMPERSONATION_TOKEN, legacyImpToken);
    console.log('[Auth Migration] Migrated impersonation_token to new key');
  }

  if (legacyImpInfo && !localStorage.getItem(AUTH_STORAGE_KEYS.IMPERSONATION_INFO)) {
    localStorage.setItem(AUTH_STORAGE_KEYS.IMPERSONATION_INFO, legacyImpInfo);
    console.log('[Auth Migration] Migrated impersonation_info to new key');
  }

  Object.values(LEGACY_STORAGE_KEYS).forEach(key => {
    localStorage.removeItem(key);
  });
  // Chiavi del vecchio tracker di inattività locale (sostituito dal motore
  // condiviso `session-idle`): pulizia one-shot anche per chi non si riautentica.
  for (const key of LEGACY_SESSION_STORAGE_KEYS.tenant) {
    localStorage.removeItem(key);
  }
  sessionStorage.removeItem('original_token');
  sessionStorage.removeItem('impersonating');
  sessionStorage.removeItem('impersonated_tenant');
  
  console.log('[Auth Migration] Cleaned up legacy keys');
}

export function clearAllAuthStorage(): void {
  Object.values(AUTH_STORAGE_KEYS).forEach(key => {
    localStorage.removeItem(key);
  });
  Object.values(LEGACY_STORAGE_KEYS).forEach(key => {
    localStorage.removeItem(key);
  });
  sessionStorage.clear();
}
